import GridView from "src/SharedComponents/GridView/GridView";
import LogoText from "src/SharedComponents/LogoText/LogoText";
import { MailIcon, PhoneIcon, MapPinIcon } from 'src/SharedComponents/Icons/Icons';
import { useAuraSupportInfo } from "src/Utils/Hooks/UseAuraInfoContext";

const Contact: React.FC = () => {
    const { adminDetails } = useAuraSupportInfo();

    return (
        <>
        {adminDetails && 
           <GridView title="Hexagon Aura Reality AG">
                <div className="d-flex flex-column">
                    <LogoText logoElement={<MailIcon />} text={adminDetails.auraSupportInfo?.email} />
                    <LogoText logoElement={<PhoneIcon />} text={adminDetails.auraSupportInfo?.contactNumber} />
                    <LogoText logoElement={<MapPinIcon />} text={adminDetails.auraSupportInfo?.streetAddress} />
                </div>
                <div>
                    <div className="row mt-3">
                            <div className="mb-2 col-9">
                                <b>Support Contact</b>
                            </div>
                    </div>
                    <LogoText logoElement={<MailIcon />} text={adminDetails.auraSupportInfo?.supportEmail} />
                    { adminDetails.auraSupportInfo?.supportContactNumber && <LogoText logoElement={<PhoneIcon />} text={adminDetails.auraSupportInfo?.supportContactNumber} /> }
                </div>
            </GridView>
        }
        </>
    )
}
export default Contact;